import { render, staticRenderFns } from "./IndigenousVoices.vue?vue&type=template&id=51b452e4&scoped=true&"
import script from "./IndigenousVoices.vue?vue&type=script&lang=js&"
export * from "./IndigenousVoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b452e4",
  null
  
)

export default component.exports